export default __webpack_public_path__ + "static/media/abstract.bf946792.png";